import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import { Divider } from '../../styles';
import { CustomerInformation } from '../../interfaces/Cart';
import TMarkUp from '../TMarkUp';

const DetailsSection = styled.div`
  padding: 1.5rem 0;

  h3 {
    margin-bottom: 1.25rem;
  }
`;

export const DetailSectionAU: React.FC<CustomerInformation> = ({
  firstName,
  lastName,
  addressFieldInfo,
  postCode,
  city,
  state,
  email,
  phoneNumber,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      <DetailsSection>
        <h3 className="h4">
          <TMarkUp value={t('spareParts.summary.delivery.title')} />
        </h3>
        <div>{`${firstName} ${lastName}`}</div>
        <div>{addressFieldInfo}</div>
        <div>{city}</div>
        <div>{`${state} ${postCode}`}</div>
        <div>{CSS_CONFIG.COUNTRY === 'au' ? 'Australia' : 'New Zealand '}</div>
      </DetailsSection>
      <Divider />
      <DetailsSection>
        <h3 className="h4">
          <TMarkUp
            value={t('spareParts.summary.delivery.contactInformation')}
          />
        </h3>
        <div>{email}</div>
        <div>{phoneNumber}</div>
      </DetailsSection>
    </>
  );
};

export default DetailSectionAU;
